import React, { useState } from 'react';
import { PaystackPayment } from './PaystackPayment';
interface PaymentFormProps {
  onSuccess?: (reference: string) => void;
}
export const PaymentForm: React.FC<PaymentFormProps> = ({
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    sex: '',
    phone: '',
    location: '',
    industry: '',
    occupation: '',
    commitment: '',
    mediaConsent: '',
    comments: ''
  });
  const [isFormComplete, setIsFormComplete] = useState(false);
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Check if required fields are complete
    setTimeout(() => {
      const requiredFields = ['email', 'fullName', 'sex', 'phone', 'location', 'industry', 'occupation', 'commitment', 'mediaConsent'];
      const isComplete = requiredFields.every(field => formData[field]);
      setIsFormComplete(isComplete && formData.email.includes('@'));
    }, 100);
  };
  return <div className="w-full max-w-lg mx-auto" data-id="element-1049" data-mp="34a0yy366gpnx">
      <div className="mb-6" data-id="element-1050" data-mp="34990mkl74dty">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-1051" data-mp="2zbhb1x80x3sx">
          Join The Networking Salon Inner Circle
        </h2>
        <p className="text-gray-600 mb-4" data-id="element-1052" data-mp="2ucw6xmpnhzz7">
          Complete the form below to join for ₦20,000 (Founder's Offer)
        </p>
      </div>
      <div className="space-y-4 mb-6" data-id="element-1053" data-mp="3rzlk8spszz0d">
        <div data-id="element-1054" data-mp="3n11sgboj3t03">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1055" data-mp="3n0ich0ifveop">
            Email <span className="text-gray-500" data-id="element-1056" data-mp="3i9tjthv0wbnz">(required)</span>
          </label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your email address" required data-id="element-1057" data-mp="3db8jlifrtrzj" />
        </div>
        <div data-id="element-1058" data-mp="9u04v7gcb891">
          <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1059" data-mp="9u9xz3wolviy">
            Full Name <span className="text-gray-500" data-id="element-1060" data-mp="243f2lynlmh51">(required)</span>
          </label>
          <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your full name" required data-id="element-1061" data-mp="291ymltimtiur" />
        </div>
        <div data-id="element-1062" data-mp="1zacgucp2cbze">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1063" data-mp="1za2q2mw720sn">
            Sex <span className="text-gray-500" data-id="element-1064" data-mp="1lat75fglsskz">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-1065" data-mp="1pdzekqfgcpt1">
            {['Male', 'Female'].map(option => <div key={option} className="flex items-center" data-id="element-1066" data-mp="1bdok7dexot34">
                <input type="radio" id={`sex-${option}`} name="sex" value={option} checked={formData.sex === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1067" data-mp="1bf9h39oq0o45" />
                <label htmlFor={`sex-${option}`} className="text-gray-700" data-id="element-1068" data-mp="35s943nvfkklg">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-1069" data-mp="z4igvl7wo57u">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1070" data-mp="z48m7kbx19vt">
            Phone Number <span className="text-gray-500" data-id="element-1071" data-mp="u5xh1mwkfnjx">(required)</span>
          </label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your phone number" required data-id="element-1072" data-mp="18ubq4fkks88x" />
        </div>
        <div data-id="element-1073" data-mp="1hsdm2gpgcapc">
          <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1074" data-mp="1hs3z71zpejnv">
            City of Residence <span className="text-gray-500" data-id="element-1075" data-mp="1cx823nfm163w">(required)</span>
          </label>
          <select id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md" data-id="element-1076" data-mp="1rrcxu85ikmgk">
            <option value="" data-id="element-1077" data-mp="3tipt05hojfzf">Select your city</option>
            <option value="Houston Texas" data-id="element-1078" data-mp="3tlc76nz2stqm">Houston Texas</option>
            <option value="Lagos" data-id="element-1079" data-mp="3olps08zot3f6">Lagos</option>
            <option value="Abuja" data-id="element-1080" data-mp="2fng78tljwxzg">Abuja</option>
            <option value="Benin City" data-id="element-1081" data-mp="2fmodzpfffccc">Benin City</option>
            <option value="Warri" data-id="element-1082" data-mp="2kmarlzz62ulo">Warri</option>
            <option value="Berlin" data-id="element-1083" data-mp="2kkzom2djpqvm">Berlin</option>
            <option value="Port Harcourt" data-id="element-1084" data-mp="2plx6edun8iwl">Port Harcourt</option>
            <option value="UK" data-id="element-1085" data-mp="2pjjbc4zyr6p1">UK</option>
            <option value="Other" data-id="element-1086" data-mp="2tnr0u4e8wqob">Other</option>
          </select>
        </div>
        <div data-id="element-1087" data-mp="1wwylxa31t4o4">
          <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1088" data-mp="1wxi3gposdr1m">
            Industry <span className="text-gray-500" data-id="element-1089" data-mp="21vjmxbq4jsdm">(required)</span>
          </label>
          <input type="text" id="industry" name="industry" value={formData.industry} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your industry" required data-id="element-1090" data-mp="25xoem4x0iexm" />
        </div>
        <div data-id="element-1091" data-mp="1e70aql3yevg9">
          <label htmlFor="occupation" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1092" data-mp="1e5fkh7oo9yo7">
            What do you do? <span className="text-gray-500" data-id="element-1093" data-mp="1i6r8x9vt8dut">(required)</span>
          </label>
          <textarea id="occupation" name="occupation" value={formData.occupation} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Describe your occupation or role" required data-id="element-1094" data-mp="1aot25d50jgva" />
        </div>
        <div data-id="element-1095" data-mp="11pzdqa1u5wst">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1096" data-mp="11ppia6y0uxfq">
            Are you committed to actively participating in the ways described
            above? <span className="text-gray-500" data-id="element-1097" data-mp="rr9t49ik1y8v">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-1098" data-mp="myqinlf5zj8a">
            {['Yes', 'No', 'I have questions'].map(option => <div key={option} className="flex items-center" data-id="element-1099" data-mp="hzdr4ndclnzd">
                <input type="radio" id={`commitment-${option}`} name="commitment" value={option} checked={formData.commitment === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1100" data-mp="hxj7dcdtc1wv" />
                <label htmlFor={`commitment-${option}`} className="text-gray-700" data-id="element-1101" data-mp="40e7ju4ozza2">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-1102" data-mp="3qk8zumqobg30">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1103" data-mp="3vgpsnu8tiimf">
            Are you okay with your pictures and videos of you taken at our
            events (in-person or online) be used for promotional purposes?{' '}
            <span className="text-gray-500" data-id="element-1104" data-mp="3ljus75szi85i">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-1105" data-mp="d2gjv93q3rua">
            {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-1106" data-mp="d5ch0v7qycho">
                <input type="radio" id={`mediaConsent-${option}`} name="mediaConsent" value={option} checked={formData.mediaConsent === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1107" data-mp="i1jo4rbvpu17" />
                <label htmlFor={`mediaConsent-${option}`} className="text-gray-700" data-id="element-1108" data-mp="89x4c6lh6mmu">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-1109" data-mp="10tvppbupkraa">
          <label htmlFor="comments" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1110" data-mp="10uf78rgg5dns">
            Additional Comments or Suggestions (You can ask your questions
            here): <span className="text-gray-500" data-id="element-1111" data-mp="2gjdb50j5k99e">(optional)</span>
          </label>
          <textarea id="comments" name="comments" value={formData.comments} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter any additional comments or questions" data-id="element-1112" data-mp="2v7rerdoe81r0" />
        </div>
      </div>
      {isFormComplete ? <PaystackPayment amount={20000} email={formData.email} name={formData.fullName} phone={formData.phone} onSuccess={onSuccess} metadata={{
      ...formData
    }} data-id="element-1113" data-mp="1xlak6g71o28y" /> : <button disabled className="w-full py-2 px-4 bg-gray-300 text-gray-500 rounded-md cursor-not-allowed" data-id="element-1114" data-mp="2bipbxrkrsm43">
          Complete all required fields to proceed
        </button>}
    </div>;
};